<template>
  <section class="section1-container">
    <div class="title-container pic-full" :class="lang"></div>
    <p class="desc-container">{{ homeLang.section1.desc }}</p>
    <div class="pic-container pic-full"></div>
    <div class="advantage-container pic-full" :class="lang">
      <div class="advantage-inner-container">
        <div 
          class="advantage-item-container pic-full" 
          v-for="(item, index) in homeLang.section1.advantage"
          :key="`adv-${index}`"
        >
          <div class="icon-container flex-center">
            <img :src="item.icon">
          </div>
          <span :class="lang">{{ item.desc }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "section1",
  props: {
    homeLang: {
      type: Object
    }
  },
}
</script>

<style lang="less">
@media screen and (min-width: 767px) {
  .section1-container {
    .title-container {
      &.zh {
        width: 4.55rem;
        height: 0.58rem;
        margin: 0.85rem auto 0;
        background-image: url("../../assets/pc/section1/title_zh.png");
      }
      &.en {
        width: 4.6rem;
        height: 0.58rem;
        margin: 0.85rem auto 0;
        background-image: url("../../assets/pc/section1/title.png");
      }
    }
    .desc-container {
      width: 9.47rem;
      font-size: 0.2rem;
      font-family: PingFangSC, PingFangSC-Regular;
      text-align: center;
      color: #333333;
      line-height: 0.28rem;
      margin: 0.24rem auto 0;
    }
    .pic-container {
      width: 11.52rem;
      height: 5.87rem;
      background-image: url("../../assets/pc/section1/xswapEcology.png");
      margin-top: -0.2rem;
    }
    .advantage-container {
      margin-top: -0.93rem;
      height: 3.42rem;
      width: 11.52rem;
      background-image: url("../../assets/pc/section1/advantageBg.png");
      .advantage-item-container {
        float: left;
        &:nth-child(1), &:nth-child(2) {
          margin-top: 0.94rem;
        }
        &:nth-child(3), &:nth-child(4) {
          margin-top: 0.18rem;
        }
        &:nth-child(1), &:nth-child(3) {
          width: 4.16rem;
          height: 0.6rem;
          margin-left: 1.17rem;
        }
        &:nth-child(2), &:nth-child(4) {
          width: 6.19rem;
          height: 0.6rem;
        }
        .icon-container {
          float: left;
          width: 0.6rem;
          height: 0.6rem;
          border-radius: 0.3rem;
          background: #edf3ff;
          border: 2px solid #dbe6ff;
          img {
            width: 0.34rem;
          }
        }
        span {
          display: block;
          float: left;
          font-size: 0.18rem;
          font-family: PingFangSC, PingFangSC-Regular;
          color: #333333;
          line-height: 0.6rem;
          margin-left: 0.17rem;
          &.zh {

          }
          &.en {
            line-height: 0.25rem;
          }
        }
        &:nth-child(1), &:nth-child(2) {
          margin-top: 0.94rem;
        }
        &:nth-child(3), &:nth-child(4) {
          margin-top: 0.18rem;
        }
        &:nth-child(1), &:nth-child(3) {
          width: 4.16rem;
          height: 0.6rem;
          margin-left: 1.17rem;
        }
        &:nth-child(2), &:nth-child(4) {
          width: 6.19rem;
          height: 0.6rem;
        }
        .icon-container {
          float: left;
          width: 0.6rem;
          height: 0.6rem;
          border-radius: 0.3rem;
          background: #edf3ff;
          border: 2px solid #dbe6ff;
          img {
            width: 0.34rem;
          }
        }
        span {
          display: block;
          float: left;
          font-size: 0.18rem;
          font-family: PingFangSC, PingFangSC-Regular;
          color: #333333;
          line-height: 0.6rem;
          margin-left: 0.17rem;
        }
      }
      &.en {
        .advantage-item-container {
          &:nth-child(1), &:nth-child(3) {
            width: 4.59rem;
            height: 0.6rem;
            margin-left: 1.17rem;
            span {
              margin-left: 0.17rem;
            }
          }
          &:nth-child(2), &:nth-child(4) {
            width: 4.69rem;
            height: 0.6rem;
            span {
              margin-left: 0.09rem;
              width: 4rem;
            }
          }
          span {
            line-height: 0.25rem;
            width: 3.6rem;
            margin-top: 0.05rem;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .section1-container {
    .title-container {
      width: 3.87rem;
      height: 0.5rem;
      background-image: url("../../assets/mobile/section1/title.png");
      margin: 0.45rem auto 0;
      &.zh {
        width: 3.92rem;
        background-image: url("../../assets/mobile/section1/title_zh.png");
      }
    }
    .desc-container {
      width: 6.49rem;
      font-size: 0.24rem;
      font-family: PingFangSC, PingFangSC-Regular;
      text-align: center;
      color: #333333;
      line-height: 0.33rem;
      margin: 0.26rem auto 0;
    }
    .pic-container {
      width: 7.5rem;
      height: 4.69rem;
      background-image: url("../../assets/mobile/section1/xswapEcology.png");
      margin-top: -0.23rem;
    }
    .advantage-container {
      height: 3.57rem;
      width: 7.1rem;
      margin: -0.79rem auto 0;
      overflow-x: auto;
      overflow-y: hidden;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE 10+ */
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      .advantage-inner-container {
        width: 8.58rem;
        .advantage-item-container {
          position: relative;
          float: left;
          width: 2.1rem;
          height: 2.5rem;
          margin-top: 0.46rem;
          margin-right: 0.06rem;
          background-image: url("../../assets/mobile/section1/bg.png");
          &:last-child {
            margin-right: 0;
          }
          .icon-container {
            width: 0.68rem;
            height: 0.68rem;
            border-radius: 0.3rem;
            background: #edf3ff;
            border: 2px solid #dbe6ff;
            margin: 0.4rem auto 0;
            //margin: 0.29rem auto 0;
            img {
              width: 0.4rem;
            }
          }
          span {
            font-size: 0.24rem;
            font-family: PingFangSC, PingFangSC-Regular;
            color: #333333;
            line-height: 0.375rem;
            margin: 0.12rem auto 0;
            display: block;
            width: 2.1rem;
            transform: scale(0.66);
            transform-origin: center 0;
            text-align: center;

            &.en {
              line-height: 0.3rem;
              margin-top: 0.06rem;
            }
          }
          &::after {
            display: block;
            content: '';
            width: 3.42rem;
            height: 3.57rem;
            margin-left: -0.66rem;
            top: -0.42rem;
            position: absolute;
            z-index: -69;
            background-image: url("../../assets/mobile/section1/bg_shadow.png");
            background-repeat: no-repeat;
            background-size: 100%;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 374px) {
  .section1-container {
    .advantage-item-container {
      span.en {
        transform: scale(0.5) !important;
      }
    }
  }
}
</style>
